<mat-sidenav-container fullscreen>
    <mat-sidenav-content>
        <app-backheader></app-backheader>
        <div  class="main-content listdimadon">
          <div class="itemsContain casioncustom  slotsmallgames">
        <ul  class="casinolistgrid">
            <ng-container *ngIf="diamondlist?.length>0">
              <li *ngFor="let x of diamondlist">
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> {{x.id}}
                            </div>
                <div *ngIf="x.imageurl" class="card-imgnew" (click)="openDiamond(x.gameId)">
                  <img  [src]="x.imageurl"
                    class="imgsize" alt="...">
                </div>
                <div class="game-detail">
                <p class="game-name">
                  {{x.name}}
                </p> 
              </div>
              </div>
              </li>       
            </ng-container>
          </ul>
        </div>
  
        <!-- casino_footer_end -->
        </div>
        <div *ngIf="diamondlist?.length==0">
          <h1 id="err_msg"> Not List Found!</h1>
        </div>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>